import { Box } from "@mui/material";
import { format } from "date-fns";
import { formatRole } from "@/utils/format-role";

export const RoleColumns = [
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Role Name</div>,
    cell: ({ row }) => (
      <Box
        sx={{
          fontSize: "0.85rem",
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        {formatRole(row.original.name) ?? "N/A"}
      </Box>
    ),
  },

  {
    accessorKey: "description",
    header: () => <div>Description</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.description ?? "N/A"}
      </div>
    ),
  },

  {
    accessorKey: "adminRole",
    header: () => <div>Type</div>,
    cell: ({ row }) => {
      const isAdmin = row.original.adminRole;

      return (
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isAdmin ? "#eef2ff" : "#f3f4f6",
            color: isAdmin ? "#3730a3" : "#374151",
            fontSize: "0.75rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {isAdmin ? "Admin Role" : "User Role"}
        </Box>
      );
    },
  },

  {
    accessorKey: "default",
    header: () => <div>Default</div>,
    cell: ({ row }) => {
      const isDefault = row.original.default;

      return (
        <Box
          sx={{
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isDefault ? "#ecfdf5" : "#f9fafb",
            color: isDefault ? "#065f46" : "#6b7280",
            fontSize: "0.75rem",
            fontWeight: 500,
          }}
        >
          {isDefault ? "Yes" : "No"}
        </Box>
      );
    },
  },

  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date Created</div>,
    cell: ({ row }) => {
      const date = row.original.createdAt;

      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      // API format: "06-01-2026 09:38:22"
      const [day, month, yearTime] = date.split("-");
      const [year, time] = yearTime.split(" ");

      const parsedDate = new Date(`${year}-${month}-${day}T${time}`);

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isNaN(parsedDate.getTime())
            ? "N/A"
            : format(parsedDate, "MMM d, yyyy")}
        </div>
      );
    },
  },
];
